import { render, staticRenderFns } from "./FancySelect.vue?vue&type=template&id=be946280&"
import script from "./FancySelect.vue?vue&type=script&lang=js&"
export * from "./FancySelect.vue?vue&type=script&lang=js&"
import style0 from "./FancySelect.vue?vue&type=style&index=0&id=be946280&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports